/**
 * Template: Collection
 * ------------------------------------------------------------------------------
 * Highly coupled scripts to power the collection page functionality.
 *
 * @namespace collection
 */
import StickyFilters from '~/components/sticky-filters';
import '~/components/show-more'

import '../../styles/templates/collection.scss';
import '../../styles/components/component-filter.scss';
import '../../styles/components/pagination.scss';
import '../../styles/components/typology-filters.scss';
  /**
   * DOM selectors.
   */
  const selectors = {
    collectionDesktopFilters: '.template-collection__tools-container'
  }
    /**
   * DOM node selectors.
   */
    const nodeSelectors = {
      collectionDesktopFilters: document.querySelector(selectors.collectionDesktopFilters),
    };

document.addEventListener('DOMContentLoaded', () => {
  if(nodeSelectors.collectionDesktopFilters !== null) {
    StickyFilters().init();
  }
});

customElements.define('read-more',
  class extends HTMLElement {
    constructor() {
      super();
      this.triggerElement = this.querySelector('.read-more__trigger');
      this.wrapperElement = this.querySelector('.read-more__wrapper');
      this.innerElement = this.querySelector('.read-more__inner');
      this.startingHeight = getComputedStyle(this.wrapperElement).getPropertyValue('--read-more-max-height');
      this.expanded = false;
    }

    connectedCallback() {
      if (this.triggerElement !== null) {
        if (this.wrapperElement.offsetHeight >= this.innerElement.offsetHeight){
          this.setAttribute('disabled', 'disabled');
          return;
        }

        this.setAttribute("data-read-more-initialized", "true");

        this.triggerElement.addEventListener('click', () => {
          const innerHeight = this.innerElement.offsetHeight;

          if (this.expanded) {
            window.requestAnimationFrame(() => {
              this.classList.remove('read-more--expanded');
              this.wrapperElement.style.setProperty('--read-more-max-height', this.startingHeight);
            });
          } else {
            this.classList.add('read-more--expanded');
            this.wrapperElement.style.setProperty('--read-more-max-height', innerHeight + 'px');
          }

          this.expanded = !this.expanded;
        });
      }
    }
  }
);
